/**
 * React Query bootstrap — safe to stay in the main bundle; avoid importing heavy feature
 * hooks/services from this file. See docs/architecture/frontend-bundling.md.
 */
import { QueryClient } from '@tanstack/react-query'

/**
 * QueryClient configuration
 * Note: Tenant-aware query key hashing is handled at the query key level
 * by prefixing query keys with tenant identifier in individual queries
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      structuralSharing: true,
      // v5 equivalent of keepPreviousData: true
      placeholderData: (previousData: unknown) => previousData,
      retry: 1,
    },
  },
})

